import {
	isStoreError,
	isStoreFollowUp,
	isStoreHuman,
	StoreActionLoggableName,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { createSafeAction, type SafeAction } from './createSafeAction';
import type { ChatStoreAction } from './types';

type RemoveMessageArgs = {
	messageId: number;
	conversationId?: string;
};

export const removeMessage: SafeAction<[RemoveMessageArgs]> = createSafeAction(
	StoreActionLoggableName.removeMessage,
	({ messageId, conversationId: conversationIdParam }: RemoveMessageArgs): ChatStoreAction =>
		async ({ getState }, { getMessages, setMessages }) => {
			const conversationId = conversationIdParam ?? getState().currentConversationId;

			const currentConversation = getState().conversations[conversationId];
			if (!currentConversation) {
				return;
			}

			const messages = getMessages(conversationId);
			const filteredMessages = messages.filter((message) => {
				if (isStoreError(message) || isStoreFollowUp(message)) {
					return message.id !== messageId;
				} else if (isStoreHuman(message)) {
					return message.content.id !== String(messageId);
				}

				// Catch-all to keep any other message type
				else {
					return true;
				}
			});

			setMessages(conversationId, filteredMessages);
		},
);
